import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          adminuserid: window.APPSETTING.adminuserid 
        }),
      });

      const data = await response.json();

      if (data.success) {
        // Store token for authenticated requests
        localStorage.setItem('authtoken', data.user.token);
        localStorage.setItem('useremail', data.user.email);
        
        // Navigate to Dashboard upon successful login
        navigate('/dashboard');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Connection to server failed');
    }
  };

  return (
    <div className="section">

       <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
       
         <div className="c-form" style={{ width: '100%', maxWidth: '400px' }}>
           <form onSubmit={handleLogin}>
              {error && <div className="error" style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
              <div className="fg">
                <label>Email</label>
                <input 
                  type="email" 
                  placeholder="name@firm.com"
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                />
              </div>
              <div className="fg">
                <label>Password</label>
                <input 
                  type="password" 
                  placeholder="••••••••"
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
              </div>
              <button type="submit" className="btn btn-dark" style={{ width: '100%', marginTop: '16px' }}>
                Login
              </button>
           </form>
         </div>
       </div>
    </div>
  );
};

// CRITICAL FIX: Export the component as default
export default Login;